<template>
  <RouterView />
</template>

<style>
@media print
{    
    .no-print, .no-print *
    {
        display: none !important;
    }
    .only-print, .only-print *
    {
        display: contents !important;
    }
    
}
</style>